import { Container } from "./styles";
import Divisor from "../../components/Divisor";

function Card({ title, link, icon, previews }) {
  return (
    <Container target="_blank" rel="noreferrer" href={link}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        <img id="icon" src={icon} />
        <h1 id="h1Title">{title}</h1>
      </span>
      <Divisor />
      <img id="preview" src={previews[0]} />
      <img id="preview" src={previews[1]} />
      <img id="preview" src={previews[2]} />
    </Container>
  );
}

export default Card;
